import styled from '@emotion/styled';
import backgroundImage from './ModalBackground.jpg';

export const Modal = styled.div`
  font-family: 'Proxima Nova';
  font-size: 16px;
  background-image: url(${backgroundImage});
  background-size: cover;
  width: 100vw;
`;

export const ModalTitle = styled.h2`
  font-family: 'Proxima Nova';
  margin-top: 32px;
`;

export const MobileFeatures = styled.div`
  margin-top: 20px;
`;
